import AccessEditorContainer from './containers/AccessEditorContainer'

export default AccessEditorContainer
